import { createRegisterableComponent } from '@news-mono/web-common'
import React from 'react'
import { BreachWallContentWrapper } from './components/BreachWallContentWrapper/BreachWallContentWrapper'
import { PuzzlesBreachWallWrapper } from './components/PuzzlesBreach/PuzzlesBreachWallWrapper'
import { BreachWallContentType } from './helpers/BreachWallTypes'

/** Common props for all breach types */
type BaseBreachScreenRegistrationProps = {
    bannerMessage?: string
    message?: string
    terms?: string
    renditionType?: string
    enableSwgCampaign?: boolean
    breachCreativeName?: string
}
/** Puzzle breach specific types */
export type PuzzleBreachRegistrationProps =
    BaseBreachScreenRegistrationProps & {
        breachwall: 'puzzles'
        breachDeal: string
        breachType: BreachWallContentType
        title: string
    }
/** Default breach specific types */
export type DefaultBreachRegistrationProps =
    BaseBreachScreenRegistrationProps & {
        breachwall?: 'default'
        breachDeal?: string
        /** Breach wall style and package to use from the offers API. Defaults to active feature toggle unless provided. */
        breachType?: BreachWallContentType
        title?: string
    }

/** A union of all possible breach types */
export type BreachScreenRegistrationProps =
    | PuzzleBreachRegistrationProps
    | DefaultBreachRegistrationProps

export const BreachScreenRegistration = createRegisterableComponent(
    'breachscreen',
    (props: BreachScreenRegistrationProps, services) => {
        if (props.breachwall === 'puzzles') {
            const enabledSwgCampaign = props.enableSwgCampaign

            return (
                <PuzzlesBreachWallWrapper
                    {...props}
                    breachType={
                        enabledSwgCampaign
                            ? 'puzzles-swg-30-off'
                            : props.breachType
                    }
                    title={
                        enabledSwgCampaign
                            ? 'Access puzzles for only 70c a day'
                            : props.title
                    }
                    requiredAccess={'subscriber'}
                    location={services.location}
                    onEvent={services.onEvent}
                    log={services.log}
                />
            )
        }

        return (
            <BreachWallContentWrapper
                {...props}
                requiredAccess={'subscriber'}
                location={services.location}
                onEvent={services.onEvent}
                log={services.log}
            />
        )
    },
)
